// extracted by mini-css-extract-plugin
module.exports = {"memberHeaderWrapper":"style__memberHeaderWrapper__A91cs","memberHeader":"style__memberHeader__7Usp0","logo":"style__logo__51jx3"};